import { initSlideshows } from "../blocks/image_slideshow";
import { footer } from "../footer";

function setThemeColor() {
  // Get first group with background color
  const firstGroupWithBG = document.querySelector(
    ".has-background.wp-block-group"
  );
  if (!firstGroupWithBG) return;

  // Get the color
  const styles = getComputedStyle(firstGroupWithBG);
  const background = styles.backgroundColor;
  if (!background) return;

  // Set the theme color
  const metaThemeColor = document.querySelector(
    "meta[name=theme-color]"
  ) as HTMLMetaElement | null;
  if (metaThemeColor) metaThemeColor.content = background;

  // Also set the background color to the header
  const header = document.querySelector("header");
  if (header) header.style.backgroundColor = background;
}

async function main() {
  footer();
  setThemeColor();
  initSlideshows();
}

main();
